// extracted by mini-css-extract-plugin
module.exports = {"heading":"OrganicMinimalHeader_heading__v4vNF","logo":"OrganicMinimalHeader_logo__2YNm1"};